import { PostDetailPage } from '~/src/components/post'

export default PostDetailPage